import React from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';
import ActiviteEntente from '../../../../../../../common/src/entities/activite-entente.entity';
import { Entente } from '../../../../../../../common/src/entities';
import { Horaire } from '../../../../../../../common/src/entities/horaire.entity';

const styles = StyleSheet.create({
    table: { width: '100%', margin: 2 },
    tableRow: { flexDirection: 'row', paddingBottom: 1 },
    tableHeader: { backgroundColor: 'black', color: 'white', padding: 1 },
    tableCell: { flex: 1, padding: 1, fontSize: 9 },
    totalRow: { fontWeight: 'bold', backgroundColor: 'black', color: 'white', padding: 1 },
});

const formatTime = (time: string) => {
    const [hours, minutes] = time.split(':');
    return `${hours} h ${minutes}`;
};

export default function DetailsActiviteEntentePDF({ horaireEntente }: { horaireEntente: Horaire }) {
    return (
        <>
            <View style={styles.table}>
                <View style={[styles.tableRow, styles.tableHeader]}>
                    <Text style={[styles.tableCell, { fontWeight: 'bold', textAlign: 'center' }]}>Horaire</Text>
                </View>
                <View style={[styles.tableRow, styles.tableHeader, { padding: 0, backgroundColor: '#2b2b2b' }]}>
                    <Text style={[styles.tableCell]}>Début</Text>
                    <Text style={[styles.tableCell]}>Fin</Text>
                    <Text style={[styles.tableCell, { flex: 2 }]}>Description</Text>
                </View>
                {horaireEntente.plagesHoraires.map((horaire, index) => (
                    <View key={index} style={styles.tableRow}>
                        <Text style={[styles.tableCell, { textAlign: 'left' }]}>{formatTime(horaire.debut)}</Text>
                        <Text style={[styles.tableCell, { textAlign: 'left' }]}>{formatTime(horaire.fin)}</Text>
                        <Text style={[styles.tableCell, { textAlign: 'left', flex: 2 }]}>{horaire.description}</Text>
                    </View>
                ))}
            </View>
        </>
    );
}
